import 'bootstrap';
import flatpickr from 'flatpickr';
import { ImagePicker, initImagePickers } from './plugins/image-picker';

// Init flatpickr on any year inputs
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-flatpickr-year]').forEach((el) => {
        flatpickr(el, { dateFormat: 'Y' });
    });

    initImagePickers();
});

window.CodeogenicImagePicker = ImagePicker;
